/* BOFA fume extraction by application (V3) — assets/abi-bofa-application.js
   Loaded only by sections/abi-bofa-application.liquid (.bap). One job: the theme's Webflow runtime (h1-custom.js)
   takes over same-page #links (#compare, #systems) and scrolls without the pinned header's offset. Unbind it so the
   browser scrolls natively with the V3 scroll-padding-top (same as disableWebflowAnchorScroll in uls-part-pdp.js). */
(function () {
  'use strict';
  if (!document.querySelector('.bap')) return;
  var off = function () {
    try { if (window.jQuery) window.jQuery(document).off('click.wf-scroll'); } catch (e) { /* no jQuery */ }
  };
  off();
  try { if (window.Webflow && typeof window.Webflow.push === 'function') window.Webflow.push(off); } catch (e) { /* no Webflow */ }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(off, 0); });
  window.addEventListener('load', off);
})();
